import { Button } from "@mui/material"

export const Buttons = (props) => {
    return (
        <Button
            id="id-button-save-ppto"
            style={{ width: '170px' }}
            className='p-btn-primary'
            variant="contained"
            size='medium'
            type={props?.type}
            onClick={props?.onClick}
        >
            {props?.label}
        </Button>
    )
}